"use client";

import React from "react";

/**
 * Маленький тумблер-переключатель — замена чекбоксам по всему порталу.
 * Размеры заданы в ПИКСЕЛЯХ через style (НЕ через Tailwind-юниты), т.к. в проекте rem=12px —
 * Tailwind w-/h- дают неожиданный размер и кружок вылазит за рамку. Кружок — absolute.
 * inline boxShadow:none нейтрализует глобальное правило свечения кнопок (globals.css).
 */
export function Toggle({
  on,
  onChange,
  disabled = false,
  title,
  className = "",
  size = "md",
}: {
  on: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean;
  title?: string;
  className?: string;
  size?: "sm" | "md";
}) {
  // sm — компактный вариант для плотных таблиц/попапов; md — дефолт по порталу.
  const dims = size === "sm" ? { w: 24, h: 14, k: 10 } : { w: 36, h: 20, k: 16 };
  const pad = 2;
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      disabled={disabled}
      data-tooltip={title}
      onClick={(e) => { e.stopPropagation(); if (!disabled) onChange(!on); }}
      className={`relative inline-block shrink-0 rounded-full p-0 align-middle transition-colors disabled:opacity-50 ${className}`}
      style={{
        width: dims.w,
        height: dims.h,
        background: on ? "var(--primary)" : "color-mix(in srgb, var(--textMuted) 45%, transparent)",
        boxShadow: "none",
      }}
    >
      <span
        className="popover-panel absolute bg-white transition-all"
        style={{ width: dims.k, height: dims.k, top: pad, left: on ? dims.w - dims.k - pad : pad }}
      />
    </button>
  );
}
